<template lang="pug">
	div
		a.wspdsc01-link-button.fs-bs(v-if="tvUrl" :href="tvUrl" target="_blank") Csatornakiosztás
		button.wspdsc01-link-button.fs-bs(v-if="isDKTV" @click="openDetailsModal") Csatornakiosztás
</template>

<script>
	import {mapActions} from 'vuex';
	import {SERVICE_TYPE_CODE} from '../../../common/constants/constants.js';
	import chnApi from '../../CHN01-channels/CHN01-channels.api.js';

	const PACKAGE_OF_PROGRAMMES = 'Műsorcsomag';

	export default {
		name: 'ChannelsLinkOrModal',
				data() {
			return {
				serviceCodes: [
					SERVICE_TYPE_CODE.ANALOG_TV,
					SERVICE_TYPE_CODE.IP_TV_FO,
					SERVICE_TYPE_CODE.IP_TV_AL,
					SERVICE_TYPE_CODE.HELYI_TV,
					SERVICE_TYPE_CODE.DIGITALIS_TV
				]
			}
		},
		props: {
			item: {
				type: Object,
				required: true
			}
		},
		computed: {
			tvUrl() {
				if (!this.serviceCodes.includes(this.item.szolgaltatasJellegKod)) {
					return '';
				}

				const packageOfProgrammeDetails = this.item.specifications.find(spec => spec.name === PACKAGE_OF_PROGRAMMES) || {};
				const anchor = packageOfProgrammeDetails.value ? `#${packageOfProgrammeDetails.value}` : '';

				return `/csatornakiosztas${anchor}`;
			},

			isDKTV() {
				return this.item.szolgaltatasJellegKod.toLowerCase() == SERVICE_TYPE_CODE.DKTV;
			}
		},
		methods: {
			...mapActions('productDetailsStore', ['setModalParameters', 'toggle']),

			async openDetailsModal() {
				try {
					const response = await chnApi.getChannels(this.item.identifier);
					let csatornak = response.data.csatornak;
					csatornak = Object.keys(csatornak).map(key => csatornak[key]).reduce((acc, curr) => {
						acc = [...acc, ...curr];
						return acc;
					}, []);

					this.setModalParameters({
						params: {
							title: this.item.serviceName,
							csatornak
						}
					});
					this.toggle();
				} catch (_e) {
					console.error(_e);
				}
			}
		}
	}
</script>



// WEBPACK FOOTER //
// ../source/modules/WSPP01-product-package/WSPP01-accordion/channels-link-or-modal.vue